import { createContext, MutableRefObject } from 'react';

const ScrollRefContext = createContext<
  MutableRefObject<HTMLElement | undefined>
>({ current: undefined });

export default ScrollRefContext;
